import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import DatePickerLocalizationAdapter from "../../../main/context/DatePickerLocalizationAdapter";
import { DatePicker, DateValidationError } from "@mui/x-date-pickers";
import { useMemo, useState } from "react";
import dayjs from "dayjs";
import { formatDate } from "../../../main/utils/utils";

export default function DateFilterRangeModal(props: {
  startDate: Date | dayjs.Dayjs | null;
  setStartDate: (startDate: Date | dayjs.Dayjs | null) => void;
  endDate: Date | dayjs.Dayjs | null;
  setEndDate: (startDate: Date | dayjs.Dayjs | null) => void;
  setOpen: (open: boolean) => void;
  open: boolean;
  title: string;
}) {
  const { startDate, setStartDate, endDate, setEndDate, title, open, setOpen } =
    props;
  const onClose = () => setOpen(false);
  const [error, setError] = useState<DateValidationError | null>(null);
  const [filterStartDate, setFilterStartDate] = useState<Date | dayjs.Dayjs | null>(
    startDate
  );
  const [filterEndDate, setFilterEndDate] = useState<Date | dayjs.Dayjs | null>(
    endDate
  );

  const errorMessage = useMemo(() => {
    switch (error) {
      case "maxDate":
      case "minDate": {
        return `Por Favor selecione uma data depois de ${formatDate(
          String(filterStartDate)
        )}`;
      }

      case "invalidDate": {
        return "Sua data é inválida";
      }

      default: {
        return "";
      }
    }
  }, [error, filterStartDate]);
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "400px",
          maxHeight: "600px",
        },
      }}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.5rem",
            },
            fontWeight: 500,
          }}
        >
          {title}
        </Typography>
      </DialogHeader>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflowY: "auto",
        }}
        dividers
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "8px",
          }}
        >
          <DatePickerLocalizationAdapter>
            <DatePicker
              format="DD/MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              maxDate={dayjs(new Date())}
              sx={{ width: "160px", marginRight: "8px" }}
              label="Data Inicial"
              value={dayjs(filterStartDate)}
              onChange={(newValue) => setFilterStartDate(newValue)}
            />
          </DatePickerLocalizationAdapter>
          <DatePickerLocalizationAdapter>
            <DatePicker
              format="DD/MM/YYYY"
              minDate={dayjs(filterStartDate)}
              maxDate={dayjs(new Date())}
              slotProps={{
                textField: { size: "small", helperText: errorMessage },
              }}
              sx={{ width: "160px" }}
              label="Data Final"
              onError={(newError) => setError(newError)}
              value={dayjs(endDate)}
              onChange={(newValue) => setFilterEndDate(newValue)}
            />
          </DatePickerLocalizationAdapter>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={error ? true : false}
          variant="contained"
          color="primary"
          onClick={() => { onClose(); setEndDate(filterEndDate); setStartDate(filterStartDate) }}
        >
          Filtrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
